// SUNY ESF's undergraduate majors (#2652). Read on 2026-10-01 from the ESF
// Academic Catalog 2026-27, Degree Programs and Areas of Study, which lists
// every registered degree program by degree. Every bachelor's program is
// kept (B.L.A. and B.S.); the catalog groups them by degree, not by
// department, so the groups here do too. Left out: the A.A.S. programs (the
// Ranger School), the B.L.A./M.S. Fast-Track (a combined graduate path),
// the "Undeclared Option" (not a major), and all graduate programs.
// Sustainability Management is the catalog's online B.S. The KB's majors
// list was the starting point; the catalog wins.
const majors = {
    "slug": "suny-college-of-environmental-science-and-forestry",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in ESF's 2026-27 Academic Catalog, grouped by the degree it leads to. Associate degrees, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor of Landscape Architecture",
            "source": {
                "label": "SUNY ESF Academic Catalog 2026-27, Degree Programs and Areas of Study",
                "url": "https://www.esf.edu/catalog/current/programs.php"
            },
            "majors": [
                {
                    "name": "Landscape Architecture",
                    "degree": "B.L.A."
                }
            ]
        },
        {
            "name": "Bachelor of Science",
            "source": {
                "label": "SUNY ESF Academic Catalog 2026-27, Degree Programs and Areas of Study",
                "url": "https://www.esf.edu/catalog/current/programs.php"
            },
            "majors": [
                {
                    "name": "Aquatic and Fisheries Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Bioprocess Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Conservation Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Education and Interpretation",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Health",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Resources Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Forest Ecosystem Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forest Health",
                    "degree": "B.S."
                },
                {
                    "name": "Forest Resources Management",
                    "degree": "B.S."
                },
                {
                    "name": "Natural Resources Management",
                    "degree": "B.S."
                },
                {
                    "name": "Paper Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainability Management",
                    "degree": "B.S.",
                    "note": "Online program."
                },
                {
                    "name": "Sustainable Energy Management",
                    "degree": "B.S."
                },
                {
                    "name": "Wildlife Science",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
